import { ObjectType, ObjectTypeConfig } from ".."
import { PRODUCT_TYPE } from "../../../product/Types"
import { PREFERENCE_TYPE } from "../../constants"
import productConfiguration from "./products"

const configuration: ObjectTypeConfig = {
    ...productConfiguration,
    objectType: ObjectType.MATRICES,
    listingPreferencesKey: PREFERENCE_TYPE.LISTING_STRUCTURES,
    searchPlaceholder: {
        id: "generic-listing.matrices.search-placeholder",
        defaultMessage: "Search matrices...",
    },
    displayString: {
        id: "generic-listing.matrices.display-string",
        defaultMessage: "Matrices",
    },
    additionalFilters: {
        type: [PRODUCT_TYPE.ASSEMBLY, PRODUCT_TYPE.MATRIX_PARENT]
    },
    creationButtonComponent: require("../../../../common/listing/generic-listing/creation-buttons/MatrixCreationButton"),
}

export default configuration


// WEBPACK FOOTER //
// ./src/state/listing/generic-listing/column-definitions/matrices.ts